import { SvgIconComponent } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CopyIcon from '@mui/icons-material/FolderCopy';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { FunctionComponent } from 'react';

type Props<Id> = {
	id: Id;
	itemName: string;
	onEdit?: (id: Id) => void;
	onDelete?: (id: Id) => void;
	onDuplicate?: (id: Id) => void;
	onPlay?: (id: Id) => void;
};

export const QuestionActions = <Id,>(props: Props<Id>) => {
	const { id, itemName, onEdit, onDelete, onDuplicate, onPlay } = props;

	return <Box>
		{onPlay && <ActionButton onClick={() => onPlay(id)} Icon={PlayArrowIcon}
			tooltip={`Play a game with this ${itemName}`} />}

		{onEdit && <ActionButton onClick={() => onEdit(id)} Icon={EditIcon}
			tooltip={`Edit ${itemName}`} />}

		{onDuplicate && <ActionButton onClick={() => onDuplicate(id)} Icon={CopyIcon}
			tooltip={`Duplicate ${itemName}`} />}

		{onDelete && <ActionButton onClick={() => onDelete(id)} Icon={DeleteIcon}
			tooltip={`Delete ${itemName}`} />}
	</Box>;
};

type ActionButtonProps = IconButtonProps & {
	tooltip: string;
	Icon: SvgIconComponent;
};
const ActionButton: FunctionComponent<ActionButtonProps> = (props) => {
	const { tooltip, Icon, ...passThrough } = props;

	return <Tooltip title={tooltip}>
		<IconButton size="small" {...passThrough}>
			<Icon fontSize="small" />
		</IconButton>
	</Tooltip >;
};